var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 18C15.3 18 13.2043 17.5207 11.163 16.562C9.12167 15.6033 7.31333 14.3367 5.738 12.762C4.16267 11.1873 2.896 9.379 1.938 7.337C0.98 5.295 0.500667 3.19933 0.5 1.05C0.5 0.75 0.6 0.5 0.8 0.3C1 0.0999999 1.25 0 1.55 0H5.6C5.83333 0 6.04167 0.0749999 6.225 0.225C6.40833 0.375 6.51667 0.566667 6.55 0.8L7.2 4.3C7.23333 4.53333 7.229 4.746 7.187 4.938C7.145 5.13 7.04933 5.30067 6.9 5.45L4.5 7.9C5.2 9.1 6.075 10.225 7.125 11.275C8.175 12.325 9.33333 13.2333 10.6 14L12.95 11.65C13.1 11.5 13.296 11.3877 13.538 11.313C13.78 11.2383 14.0173 11.2173 14.25 11.25L17.7 11.95C17.9333 12 18.125 12.1127 18.275 12.288C18.425 12.4633 18.5 12.6673 18.5 12.9V16.95C18.5 17.25 18.4 17.5 18.2 17.7C18 17.9 17.75 18 17.45 18Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSolid);
export default __webpack_public_path__ + "static/media/phone-solid.b2725ec86f1f3c96df5a03cee1ec2f37.svg";
export { ForwardRef as ReactComponent };